import React, { Component } from "react";
import LineGraph from "../../components/common/ant-novak/ChartJS/LineGraph";
// import LineGraph from "../UI/ChartJS/LineGraph";
import { FRF } from "./BandPass.helper";

class BandPassGraph extends Component {
  render() {
    // List of inputs ("props") :
    //   f1 [Hz] ... low cut-off frequency
    //   f2 [Hz] ... high cut-off frequency
    const { f1, f2 } = this.props;

    // abs and phase
    const { FRF_abs } = FRF(f1, f2);

    const data = {
      xAxes: {
        xLabel: "Frequency (Hz)",
        type: "logarithmic",
      },
      yAxes: [
        {
          data: [FRF_abs],
          yLabel: "FRF (dB)",
          type: "linear",
          min: -50,
          max: 10,
        },
      ],
      animation: 0,
    };

    return <LineGraph data={data} graph_size_ratio={0.65} />;
  }
}
export default BandPassGraph;
